window.addEventListener('DOMContentLoaded', (event) => {
	const loadMore = document.getElementById('load-more');
	const currentLanguage = document.getElementById('language');
	const s = document.getElementById('s');

	if (loadMore) {
		loadMore.addEventListener('click', function (e) {
			e.preventDefault();

			const currentPage = this.dataset.currentPage
				? parseInt(this.dataset.currentPage)
				: 1;

			const get = new URLSearchParams();
			get.set('page', currentPage + 1);
			get.set('search', s.value);
			get.set('lang', currentLanguage ? currentLanguage.value : 'en');

			const xmlhttp = new XMLHttpRequest();

			xmlhttp.onreadystatechange = function () {
				if (xmlhttp.readyState == XMLHttpRequest.DONE) {
					if (xmlhttp.status === 200) {
						const totalPages =
							xmlhttp.getResponseHeader('X-WP-TotalPages');
						const results = JSON.parse(this.response);

						results.forEach(function (result) {
							console.log(result.location);

							const locationTemplate =
								typeof result.location !== 'undefined' &&
								result.location
									? `<i class="icon-pin purple icon-pin--space"></i><span>${result.location} | </span>`
									: ``;
							const template = `<article class="result-item">
                <h2 class="result-title"><a href="${result.url}">${result.post_title}</a></h2>
                <div class="result-copy">
                  <span>${result.display_type} | </span> ${locationTemplate}
                  ${result.excerpt}
                </div>
              </article>`;

							const resultContainer =
								document.createElement('div');
							resultContainer.classList.add(
								'container',
								'results-container'
							);

							resultContainer.innerHTML = template;

							const loadMoreContainer = document.getElementById(
								'load-more-container'
							);

							if (loadMoreContainer) {
								loadMoreContainer.parentNode.insertBefore(
									resultContainer,
									loadMoreContainer
								);
							}

							// Determine if we should hide the load more button or not
							if (
								parseInt(totalPages) ===
								parseInt(currentPage + 1)
							) {
								loadMore.classList.add('hidden');
							} else {
								loadMore.dataset.currentPage = currentPage + 1;
							}
						});
					}
				}
			};

			xmlhttp.open(
				'GET',
				'/wp-json/aftermetoo/v2/search?' + get.toString(),
				true
			);
			xmlhttp.send();

			return false;
		});
	}
});
